import service from './base'
import setSignHead from './setSignHead'
const BASE_URL = '/'
const http = service.service
export const goToPay = (params = {}) => {
    setSignHead.setCmdType('appUnifiedOrder')
    return http.post(`${BASE_URL}AppServerWhpe/com/whpe/pay`, params)
}
export const getQrcodeInfo = (params = {}) => {
    setSignHead.setCmdType('cardInfoCheck')
    return http.post(`${BASE_URL}AppServerWhpe/com/whpe/qrcode`, params)
}
export const goRefund = (params = {}) => {
    return http.post(`${BASE_URL}AppServerWhpe/com/whpe/refund/createRefundOrder`, params)
}